// ? all carbon are in ton unit,
// ? all prices are in GBP currency
export const ANNUAL_AVERAGE_EMISSIONS = 10;
export const ONE_TON_OF_CARBON_PRICE = 10.8;
export const TREES_COST = 1.44;